<template>
  <section
    class="roadmap section"
    :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]"
  >
    <div class="container">
      <div
        class="roadmap-inner section-inner"
        :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <c-timeline>
          <c-timeline-item
            title="Checkpoint 0: Discovery Call(s)"
          >I join you and your client for preliminary Discovery calls, to establish whether I can help and prepare a detailed project roadmap.</c-timeline-item>
          <c-timeline-item title="Checkpoint 1: Proof of Concept (Week 1)">
            My projects start with a
            <mark>working</mark> Proof of Concept app (custom) that demonstrates my understanding of your client's objectives.
          </c-timeline-item>
          <c-timeline-item
            title="Checkpoint 2: Project Start (Week 2)"
          >After establishing the problem domain, your client's business objective, and the solution you have envisioned together, I dive into the architecture and code.</c-timeline-item>
          <c-timeline-item title="Checkpoint 3: First Demo (Week 4)">
            By the end of our first month together, I set up 2 live demos: the first is for you: to verify I'm on the right track. The second is for your client: they're thrilled to play with a
            <mark>working</mark> early release and give feedback.
          </c-timeline-item>
          <c-timeline-item
            title="Checkpoint 4: Second Demo (Week 6)"
          >Based on feedback of the previous demo, I release a "feature complete" second demo. This is the full MVP of your client's original idea and/or wireframes.</c-timeline-item>
          <c-timeline-item
            title="Checkpoint 5: Documentation, Handoff (Week 6~8)"
          >After your client is satisfied they've got a working business asset they can use to develop their sales, then I hand-off the code and write documentation for future programmers to take over.</c-timeline-item>
        </c-timeline>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CTimeline from "@/components/elements/Timeline.vue";
import CTimelineItem from "@/components/elements/TimelineItem.vue";

export default {
  name: "CRoadmap",
  components: {
    CSectionHeader,
    CTimeline,
    CTimelineItem
  },
  mixins: [SectionProps],
  data() {
    return {
      sectionHeader: {
        title: `A process that you can monitor & verify at each checkpoint.`,
        paragraph: `I'm a solo independent Canadian web application developer, not an outsourced team. That makes things a lot simpler.`
      }
    };
  }
};
</script>